module.exports = __webpack_public_path__ + "static/media/PICTOS_IRIS_MAGAZINE.3319e7a8.png";